import React, { useState, useEffect } from "react";
import TimLogo from "../../Assets/tim-lama.jpeg";
import DashboardIcon from "../../Assets/dashboard-icon.png";
import BudgetIcon from "../../Assets/budget-icon.png";
import RequestIcon from "../../Assets/request-item-icon.png";
import ApprovalIcon from "../../Assets/approval-icon.png";
import SupplierIcon from "../../Assets/supplier.png";
import PoIcon from "../../Assets/po-icon.png";
import ChangePassword from "../../Assets/change-password.png";
import LogoutIcon from "../../Assets/logout-icon.png";
import InventoryIcon from "../../Assets/inventory-icon.png";
import PopUpComponent from "../PopUp/PopUpComponent";
import { useHistory } from "react-router-dom";
import CloseLogo from "../../Assets/close_icon.png";
import { postAxios } from "../../util/apiCall";
import "./MenuComponent.css";

const MenuComponent = ({ setMenu, menu }) => {
  let history = useHistory();
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [popUpChangePassword, setPopUpChangePassword] = useState(false);
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();

  const [popUpDataPerusahaan, setPopUpDataPerusahaan] = useState(false);
  const [npwp, setNpwp] = useState();
  const [alamatNpwp, setAlamatNpwp] = useState();
  const [alamatKirim, setAlamatKirim] = useState();
  const [tlp, setTlp] = useState();
  const [fax, setFax] = useState();
  const [email, setEmail] = useState();
  const [direktur, setDirektur] = useState();
  const [kabag, setKabag] = useState();
  const [isReload, setIsReload] = useState(false);

  const [code, setCode] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getDataPerusahaan`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      (res) => {
        setTlp(res?.tlp || "");
        setNpwp(res?.npwp || "");
        setAlamatNpwp(res?.alamatNpwp || "");
        setAlamatKirim(res?.alamatKirim || "");
        setFax(res?.fax || "");
        setEmail(res?.email || "");
        setDirektur(res?.direktur || "");
        setKabag(res?.kabag || "");
      },
      ""
    );
    setIsReload(false);
  }, [isReload]);

  const handleLogout = () => {
    localStorage.removeItem("auth");
    history.push("/login");
  };

  const handleCloseGantiPassword = () => {
    setOldPassword();
    setNewPassword();
    setPopUpChangePassword(false);
    handleLogout();
  };

  const handleChangePassword = () => {
    if (oldPassword && newPassword) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/changePassword`,
        {
          id: dataUser.id,
          oldPassword: oldPassword,
          newPassword: newPassword,
        },
        dataUser.auth,
        setCode,
        ""
      );
      if (code === 200) {
        handleCloseGantiPassword();
        handleLogout();
      }
    }
  };

  const pickMenu = (data, slug) => {
    if (data) {
      history.push(`/${data}`);
      setMenu(data);
    }
  };

  const handleChangeDataPerusahaan = () => {
    if (npwp && alamatNpwp && alamatKirim && tlp && fax && email) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editDataPerusahaan`,
        {
          tim: dataUser.tim,
          npwp: npwp,
          alamatNpwp: alamatNpwp,
          alamatKirim: alamatKirim,
          tlp: tlp,
          fax: fax,
          email: email,
          direktur: direktur,
          kabag: kabag,
        },
        dataUser.auth,
        setCode,
        ""
      );

      setTimeout(() => {
        setPopUpDataPerusahaan(false);
        setIsReload(true);
      }, 300);
    }
  };

  return (
    <>
      {popUpChangePassword ? (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <div>
              <p
                style={{
                  margin: "6px 0",
                }}
              >
                Password Lama
              </p>
              <input
                style={{
                  padding: "6px",
                }}
                type="text"
                placeholder="Password Lama"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </div>
            <div>
              <p
                style={{
                  margin: "6px 0",
                }}
              >
                Password Baru
              </p>
              <input
                style={{
                  padding: "6px",
                }}
                type="text"
                placeholder="Password Baru"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => setPopUpChangePassword(false)}
              alt="edit_logo"
            />
          </div>
          <div
            className="wrapper-button-tambah-bpb"
            style={{
              margin: "12px 0 0 0",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={() => handleChangePassword()}
              className="button-tambah-bpb font10-mobile-bpb"
              style={{
                background: "red",
                color: "white",
                padding: "8px 18px",
              }}
            >
              Ganti
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDataPerusahaan ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            overflowY: "auto",
            padding: "24px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <div className="popup-company-content">
            <div className="popup-header" style={{ marginBottom: "12px" }}>
              <h2 className="popup-title">Data Perusahaan</h2>

              <img
                className="img-close-popup-bpb"
                src={CloseLogo}
                onClick={() => setPopUpDataPerusahaan(false)}
                alt="edit_logo"
              />
            </div>

            <div className="popup-company-form">
              <div className="popup-company-row">
                <p className="popup-company-label">N.P.W.P</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="No. NPWP"
                  value={npwp}
                  onChange={(e) => setNpwp(e.target.value)}
                />
              </div>
              <div className="popup-company-row popup-company-row-textarea">
                <p className="popup-company-label">Alamat NPWP</p>

                <textarea
                  className="popup-company-textarea"
                  placeholder="Alamat NPWP"
                  value={alamatNpwp}
                  onChange={(e) => setAlamatNpwp(e.target.value)}
                />
              </div>

              <div className="popup-company-row popup-company-row-textarea">
                <p className="popup-company-label">Alamat Kirim</p>

                <textarea
                  className="popup-company-textarea"
                  placeholder="Alamat Kirim"
                  value={alamatKirim}
                  onChange={(e) => setAlamatKirim(e.target.value)}
                />
              </div>

              <div className="popup-company-row">
                <p className="popup-company-label">Telpon</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="No. Telpon"
                  value={tlp}
                  onChange={(e) => setTlp(e.target.value)}
                />
              </div>

              <div className="popup-company-row">
                <p className="popup-company-label">Fax</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="Fax"
                  value={fax}
                  onChange={(e) => setFax(e.target.value)}
                />
              </div>

              <div className="popup-company-row">
                <p className="popup-company-label">Email</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="popup-company-row">
                <p className="popup-company-label">Direktur</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="Direktur"
                  value={direktur}
                  onChange={(e) => setDirektur(e.target.value)}
                />
              </div>

              <div className="popup-company-row">
                <p className="popup-company-label">Ka. Bag. Pembelian</p>

                <input
                  className="popup-company-input"
                  type="text"
                  placeholder="Kabag"
                  value={kabag}
                  onChange={(e) => setKabag(e.target.value)}
                />
              </div>
            </div>

            <div className="popup-footer">
              <button
                onClick={() => handleChangeDataPerusahaan()}
                className="button-create-po"
              >
                Kirim
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="show-menu-mobile hide-menu-desktop">
        <div
          style={{
            display: "flex",
            overflow: "auto",
            alignItems: "center",
            background: "white",
          }}
        >
          <img
            src={DashboardIcon}
            className={
              menu === "dashboard"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            onClick={() => pickMenu("dashboard", "/dashboard")}
          />
          <img
            className={
              menu === "bpb" ? "img-menu-mobile-active" : "img-menu-mobile"
            }
            src={RequestIcon}
            onClick={() => pickMenu("bpb", "/bpb")}
          />
          <img
            className={
              menu === "purchase-order"
                ? "img-menu-mobile-active"
                : "img-menu-mobile"
            }
            src={PoIcon}
            onClick={() => pickMenu("purchase-order", "/purchase-order")}
          />

          <img
            style={{
              width: "24px",
              height: "24px",
              margin: "12px 12px 12px 36px",
            }}
            src={ChangePassword}
            onClick={() => setPopUpChangePassword(true)}
          />
          <img
            style={{
              width: "24px",
              height: "24px",
              margin: "12px 12px 12px 36px",
            }}
            src={LogoutIcon}
            onClick={() => handleLogout()}
          />
        </div>
      </div>
      <div
        className="hide-menu-mobile"
        style={{
          background: "#e5f4d4",
          width: "196px",
          minHeight: "100vh",
          position: "fixed",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            style={{ width: "64px", marginTop: "12px", cursor: "pointer" }}
            src={TimLogo}
            alt="logo"
            onClick={() => setPopUpDataPerusahaan(true)}
          />
        </div>
        <div>
          <div>
            <div
              className="wrapper-menu-component"
              onClick={() => pickMenu("dashboard", "/dashboard")}
            >
              <label
                className={
                  menu === "dashboard" ? "menu-marker" : "display-none-menu"
                }
              >
                a
              </label>
              <img
                className={
                  menu === "dashboard"
                    ? "img-menu-component img-menu-active"
                    : "img-menu-component"
                }
                src={DashboardIcon}
              />
              <p className={menu === "dashboard" ? "menu-active" : "menu"}>
                Dashboard
              </p>
            </div>
          </div>
          <div
            className="wrapper-menu-component"
            onClick={() => pickMenu("bpb", "/bpb")}
          >
            <label
              className={menu === "bpb" ? "menu-marker" : "display-none-menu"}
            >
              a
            </label>
            <img
              className={
                menu === "bpb"
                  ? "img-menu-component img-menu-active"
                  : "img-menu-component"
              }
              src={RequestIcon}
            />
            <p className={menu === "bpb" ? "menu-active" : "menu"}>BPB</p>
          </div>
          {dataUser.role !== "direksi_tim" ? (
            <>
              <div
                className="wrapper-menu-component"
                onClick={() => pickMenu("inventory", "/inventory")}
              >
                <label
                  className={
                    menu === "inventory" ? "menu-marker" : "display-none-menu"
                  }
                >
                  a
                </label>
                <img
                  className={
                    menu === "inventory"
                      ? "img-menu-component img-menu-active"
                      : "img-menu-component"
                  }
                  src={InventoryIcon}
                />
                <p className={menu === "inventory" ? "menu-active" : "menu"}>
                  Inventory
                </p>
              </div>
              <div
                className="wrapper-menu-component"
                onClick={() => pickMenu("purchase-order", "/purchase-order")}
              >
                <label
                  className={
                    menu === "purchase-order"
                      ? "menu-marker"
                      : "display-none-menu"
                  }
                >
                  a
                </label>
                <img
                  className={
                    menu === "purchase-order"
                      ? "img-menu-component img-menu-active"
                      : "img-menu-component"
                  }
                  src={PoIcon}
                />
                <p
                  className={menu === "purchase-order" ? "menu-active" : "menu"}
                >
                  Purchase Order
                </p>
              </div>
              <div
                className="wrapper-menu-component"
                onClick={() => pickMenu("list-vendor", "/list-vendor")}
              >
                <label
                  className={
                    menu === "list-vendor" ? "menu-marker" : "display-none-menu"
                  }
                >
                  a
                </label>
                <img
                  className={
                    menu === "list-vendor"
                      ? "img-menu-component img-menu-active"
                      : "img-menu-component"
                  }
                  src={SupplierIcon}
                />
                <p className={menu === "list-vendor" ? "menu-active" : "menu"}>
                  List Vendor
                </p>
              </div>
            </>
          ) : (
            ""
          )}

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div
            className="wrapper-menu-component"
            onClick={() => setPopUpChangePassword(true)}
          >
            <p style={{ margin: "12px 0 12px 24px", color: "#A3CDE8" }}>
              Change Password
            </p>
          </div>
          <div
            className="wrapper-menu-component"
            onClick={() => handleLogout()}
          >
            <img className="img-menu-component " src={LogoutIcon} />
            <p style={{ margin: "0" }}>Sign Out</p>
          </div>
        </div>
      </div>
    </>
  );
};
export default MenuComponent;
